import ButtonBase, {
  IButtonBaseProps,
  TitanButtonTextColor
} from "../ButtonBase"

export interface IButtonStandardProps
  extends Omit<IButtonBaseProps, "color" | "icon" | "textColor" | "variant"> {}

// App-wide Standard Button with blue text
const Button: React.FunctionComponent<IButtonStandardProps> = props => {
  return <ButtonBase {...props} textColor={TitanButtonTextColor.Standard} />
}

export default Button
